import { isBrowser } from "./browser.helper";
import { setCookieItem, getCookieItem, removeCookieItem } from "./browser-cookie.helper";
import { MONTANA_CART } from "@montana/constants/cookie";

const ONE_WEEK_IN_MS = 604800000;

export function getCartCookie(): string | undefined {
    if (!isBrowser) {
        return;
    }

    return getCookieItem(MONTANA_CART);
}

export function setCartCookie(cartId: string): void {
    isBrowser && setCookieItem(MONTANA_CART, cartId, `${new Date(Date.now() + ONE_WEEK_IN_MS).toUTCString()}`)
}

export function deleteCartCookie(): void {
    isBrowser && removeCookieItem(MONTANA_CART);
}
